module.exports = __webpack_public_path__ + "static/media/qr.940cc365.svg";